import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import styles from './TripCard.module.css';
import type { TripCardFooterProps } from './TripCard.types';
import { TripCardCta } from './TripCardCta';
const TripCardFooter = t0 => {
  const $ = _c(9);
  const {
    price,
    nights,
    isLoading
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] !== nights || $[1] !== price || $[2] !== t) {
    t1 = (price || nights) && <div className={styles.priceNights}>{price && <span className={styles.priceLine}><span className={styles.priceFrom}>{t("common.from")}</span><span data-test-id="trip-card-price" className={styles.price}>{t("common.price_pp", {
            price
          })}</span></span>}{nights && <span className={styles.priceNightsText}>{price && "/ "}{t("content.forms.nights_count", {
          count: nights
        })}</span>}</div>;
    $[0] = nights;
    $[1] = price;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== isLoading) {
    t2 = <TripCardCta isLoading={isLoading} />;
    $[4] = isLoading;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className={styles.footerRow}>{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export { TripCardFooter };